export enum FileMimetypesEnum {
  pdf = 'application/pdf',
  image = 'image/*',
  spreadsheet = '.csv, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv, application/csv',
}
